module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“Well, for now,” Ginger said “I’d recommend you keep your mouth shut.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie nodded. “But this should be a major story. Did you hear anything on the news yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger shook her head. “No, but that doesn’t mean anything. I sometimes get busy and don’t bother watching the news. Anyway, it’s always so depressing, who needs it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’d better get back and see what else he’s saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They strolled back and melted into the edge of the group surrounding Nick and Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark looked up and said, “Harrie, has DJ said anything to you about this body Nick discovered?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie’s heart slammed into her chest. Her reaction surprised her as much as his question. Time seemed to stop. In reality, she knew only a few awkward seconds had passed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took a breath. “No, but why would he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark grinned at her. “Don’t forget. I graduated from the FBI Citizens Academy. They taught us the FBI has jurisdiction on most federal lands. I figured they were brought in on something like finding a body at a National Monument.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie’s heart resumed its normal pace. She shrugged. “I’m not sure that always applies. Anyway, DJ wouldn’t discuss something like that with me. These guys are very tight-lipped. What happens at the FBI—stays at the FBI. They certainly don’t discuss current cases with their families.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark scratched his chin. “Hmm,” he said. “I guess it makes sense.” His eyes brightened, and his grin returned. “But what if you became involved in the case?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie frowned. “I’m not following you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” Mark said, “weren’t you involved with a murder case not too long ago? Steve mentioned something at the meeting last week. He said it also involved DJ.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Harrie and Ginger looked at each other. Harrie bit her lower lip. “That was different. I got involved in an incident ….” She stopped and started over. “To be more precise, Ginger and I became involved in an investigation of a disappearance. We ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("discovered it had a connection to one of DJ’s cases. It was pure coincidence.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger grinned. “We’ve stumbled into other murders over the past few years. Those were also connected to the FBI.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stopped and held up both hands to forestall Harrie’s inevitable reaction. “But those were flukes—nothing but flukes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark’s eyebrows raised. “Were you in the wrong place at the right time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger said, “Let’s say Harrie has a talent for finding trouble.” She put her arm around Harrie’s shoulders and gave her a look that said, “Stay cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie nodded and blew out the breath she didn’t even realize she’d been holding. “That’s me, all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They stood around, chatting with the hams, watching the drones take off and land. Ginger stood with Steve and the boys, watching drones, while Harrie talked to Nick. She asked for his email address and provided a scrap of paper from her purse to write on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now, other drone enthusiasts had arrived, and at least four of the units were buzzing overhead. Not even the discovery of a body could keep attention on earthly matters when flying machines were present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie and Ginger eased away from the crowd again. None of the group took notice. The aerial display seemed to completely captivate Steve and the boys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger said, “We need to talk. I’ll tell Steve we’re leaving—if I can get his attention long enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie noticed Nick Ellis now involved in getting his own drone ready for flight. She tucked away the paper on which he had jotted his email address. Maybe they could meet somewhere for coffee. She had a lot of questions but didn’t want an audience around when she asked them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d93fb08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter05.vue
// module id = 84
// module chunks = 0